/**
 * Javascript file for the registration successful page.
 * @author Adrian Rebmann, Steffen Schuhmann, Andrea Villeda
 */

export default {
  name: "SignupSuccess",

  /**
   * The vue instance's data object.
   */
  data() {
    return {};
  },

  /**
   * Called after the instance has been mounted.
   */
  mounted() {
    //console.log("HELL YEAH");
    window.setTimeout(() => {
      this.$router.push({ name: "Welcome" });
    }, 8000);
  }
};



// WEBPACK FOOTER //
// ./src/components/app/authentication/signup/success/signupsuccess.js